<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('identity_information').toUpper() }}</h5>
        <div class="border rounded p-4 mb-3">
            <b-row>
                <b-col cols="12" md="3">
                    <div class="label-as-input-div">
                        <label>{{ $t('national_id') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'national_id') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('name') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('surname') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'surname') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('gender') }}</label>
                        <div>
                            {{ this.getLocaleText(studentProgram, 'gender') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="3">
                    <div class="label-as-input-div">
                        <label>{{ $t('father_name') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'father_name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('mother_name') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'mother_name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('date_of_birth') }}</label>
                        <div>
                            {{ studentProgram.birthdate ? this.toLocaleDate(studentProgram.birthdate) : '-' }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('birthplace') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'birthplace') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="3">
                    <div class="label-as-input-div">
                        <label>{{ $t('nationality') }}</label>
                        <div>
                            {{ this.getLocaleText(studentProgram, 'nationality_name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('passport_number') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'passport_number') }}
                        </div>
                    </div>

<!--                    <div class="label-as-input-div">
                        <label>{{ $t('city') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'city_name') }}
                        </div>
                    </div>-->
<!--                    <div class="label-as-input-div">
                        <label>{{ $t('district') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'district_name') }}
                        </div>
                    </div>-->
                    <div v-if="isAdmin">
                        <div class="label-as-input-div">
                            <label>{{ $t('lms_id') }}</label>
                            <div>
                                {{ this.getObjectValue(studentProgram, 'lms_id') }}
                            </div>
                        </div>
                        <div class="label-as-input-div">
                            <label>{{ $t('microsoft_user_id') }}</label>
                            <div>
                                {{ this.getObjectValue(studentProgram, 'microsoft_user_id') }}
                            </div>
                        </div>
                    </div>

                </b-col>
                <b-col cols="12" md="3">
                    <div class="label-as-input-div">
                        <label>{{ $t('minister_order_date') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'minister_order_date') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('minister_order_number') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'minister_order_number') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('rector_order_date') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'rector_order_date') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('rector_order_number') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'rector_order_number') }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_identityupdate') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal"
                     size="xl"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_identityupdate') && editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        computed:{
            isAdmin() {
                return this.$store.getters['auth/isAdmin'];
            },
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

